var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon(20)",
    clipPath: "url(#clip0_2249_7788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7363 12.7976V3.61914",
    stroke: "#1D1D1D",
    strokeWidth: 1.75177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.9487 12.7988V17.3881C17.9487 17.5619 17.8796 17.7287 17.7567 17.8516C17.6337 17.9746 17.467 18.0437 17.2931 18.0437H4.18099C4.00712 18.0437 3.84036 17.9746 3.71741 17.8516C3.59446 17.7287 3.52539 17.5619 3.52539 17.3881V12.7988",
    stroke: "#1D1D1D",
    strokeWidth: 1.75177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.015 9.51953L10.737 12.7976L7.45898 9.51953",
    stroke: "#1D1D1D",
    strokeWidth: 1.75177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2249_7788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.9793,
    height: 20.9793,
    fill: "white",
    transform: "translate(0.24707 0.341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b1e761cd0c910b7b214e2ca50332d550.svg";
export { ForwardRef as ReactComponent };